const selectChangeSlaId = 'timing';
const requiresNetworkItSecurityApprovalId = 'it_approval_required';
const whyNoNetworkItSecurityApprovalId = 'it_approval_exclusion';
const impactId = 'impact';
const changeImpactTechnologyRecoverPlanId = 'technology_plan_required';
const whyNoImpactOnTechnologyRecoverPlanId = 'technology_plan_exclusion';
const customerImpactingId = 'customer_impact';


export {
  selectChangeSlaId,
  requiresNetworkItSecurityApprovalId,
  whyNoNetworkItSecurityApprovalId,
  impactId,
  changeImpactTechnologyRecoverPlanId,
  whyNoImpactOnTechnologyRecoverPlanId,
  customerImpactingId,
};

